<template>
    <div>
        <buttonlist @help="help" @opentable="opentable" @add="add" @search="search" @reflash="reflash" @exps="exps" @save="save" @del="del" @execute="execute" @print='print'
                    ref="SetBtn"></buttonlist>
        <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
            <li class="left" ref="left">
                <el-tabs :tab-position="'top'" type="" @tab-click="selectInfo">
                    <el-tab-pane :label="$t('getapi[945]')" name="0">
                        <wTable
                                id="xpane-0"
                                :data="dataSet"
                                :loading="loading"
                                queryData="ProSOCollecIssueHeadBoardViewInfo"
                                :filter_language="['finance_status','order_statusname','negative_flag']"
                                :header="tableHeader"
                                :option="tableOption"
                                @edits="editInfo"
                                @rowdblclick="openEdit"
                                ref="singleTable"
                                :checkflg="false"
                        ></wTable>
                        <!--<el-table
                                :data="dataSet"
                                ref="singleTable"
                                v-loading="loading"
                                :highlight-current-row="true"
                                show-overflow-tooltip="true"
                                border
                                stripe
                                size="mini"
                                @row-click="editInfo"
                                @row-dblclick="openEdit"
                                @selection-change="handleSelectionChange"
                                :height="tableHeight - reduceTableHeight"
                                header-row-class-name="headerclass"
                                style="width: 100%; margin-top:0px"
                        >
                            <el-table-column type="selection" v-if="false"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="order_no" :label="$t('getapi[463]')" width="120"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="order_statusname" :label="$t('getapi[552]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="coll_sign" :label="$t('getapi[4642]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="finance_status" :label="$t('getapi[1862]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="finance_date" :label="$t('getapi[1857]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="issue_dept" :label="$t('getapi[2180]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="create_person" :label="$t('getapi[3690]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="create_time" :label="$t('getapi[4583]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="modify_person" :label="$t('getapi[733]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="modify_time" :label="$t('getapi[1210]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="audit_person" :label="$t('getapi[4584]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="audit_time" :label="$t('getapi[4585]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="regist_person" :label="$t('getapi[4470]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="keep_person" :label="$t('getapi[4472]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="negative_flag" :label="$t('getapi[2096]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="base_order_no" :label="$t('getapi[2203]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="remark" :label="$t('getapi[143]')"></el-table-column>
                        </el-table>-->
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[1422]')" name="1">
                        <wTable
                                id="xpane-1"
                                :data="dataSet1"
                                :loading="loading"
                                queryData="ProSOCollecIssueHeadBoardViewInfo"
                                :filter_language="['finance_status','order_statusname','negative_flag']"
                                :header="tableHeader"
                                :option="tableOption"
                                @edits="editInfo"
                                @rowdblclick="openEdit"
                                ref="singleTable1"
                                :checkflg="false"
                        ></wTable>
                        <!--<el-table
                                :data="dataSet1"
                                ref="singleTable1"
                                v-loading="loading"
                                :highlight-current-row="true"
                                show-overflow-tooltip="true"
                                border
                                stripe
                                size="mini"
                                :height="tableHeight - reduceTableHeight"
                                @row-click="editInfo"
                                @row-dblclick="openEdit"
                                @selection-change="handleSelectionChange1"
                                header-row-class-name="headerclass"
                                style="width: 100%; margin-top:0px"
                        >
                            <el-table-column type="selection" v-if="false"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="order_no" :label="$t('getapi[463]')" width="120"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="order_statusname" :label="$t('getapi[552]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="coll_sign" :label="$t('getapi[4642]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="finance_status" :label="$t('getapi[1862]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="finance_date" :label="$t('getapi[1857]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="issue_dept" :label="$t('getapi[2180]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="create_person" :label="$t('getapi[3690]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="create_time" :label="$t('getapi[4583]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="modify_person" :label="$t('getapi[733]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="modify_time" :label="$t('getapi[1210]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="audit_person" :label="$t('getapi[4584]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="audit_time" :label="$t('getapi[4585]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="regist_person" :label="$t('getapi[4470]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="keep_person" :label="$t('getapi[4472]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="negative_flag" :label="$t('getapi[2096]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="base_order_no" :label="$t('getapi[2203]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="remark" :label="$t('getapi[143]')"></el-table-column>
                        </el-table>-->
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[2408]')" name="2">
                        <wTable
                                id="xpane-2"
                                :data="dataSet2"
                                :loading="loading"
                                queryData="ProSOCollecIssueHeadBoardViewInfo"
                                :filter_language="['finance_status','order_statusname','negative_flag']"
                                :header="tableHeader"
                                :option="tableOption"
                                @edits="editInfo"
                                @rowdblclick="openEdit"
                                ref="singleTable2"
                                :checkflg="false"
                        ></wTable>
                        <!--<el-table
                                :data="dataSet2"
                                ref="singleTable2"
                                v-loading="loading"
                                :highlight-current-row="true"
                                show-overflow-tooltip="true"
                                border
                                stripe
                                size="mini"
                                :height="tableHeight - reduceTableHeight"
                                @row-click="editInfo"
                                @row-dblclick="openEdit"
                                @selection-change="handleSelectionChange2"
                                header-row-class-name="headerclass"
                                style="width: 100%; margin-top:0px"
                        >
                            <el-table-column type="selection" v-if="false"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="order_no" :label="$t('getapi[463]')" width="120"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="order_statusname" :label="$t('getapi[552]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="coll_sign" :label="$t('getapi[4642]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="finance_status" :label="$t('getapi[1862]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="finance_date" :label="$t('getapi[1857]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="issue_dept" :label="$t('getapi[2180]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="create_person" :label="$t('getapi[3690]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="create_time" :label="$t('getapi[4583]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="modify_person" :label="$t('getapi[733]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="modify_time" :label="$t('getapi[1210]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="audit_person" :label="$t('getapi[4584]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="audit_time" :label="$t('getapi[4585]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="regist_person" :label="$t('getapi[4470]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="keep_person" :label="$t('getapi[4472]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="negative_flag" :label="$t('getapi[2096]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="base_order_no" :label="$t('getapi[2203]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="remark" :label="$t('getapi[143]')"></el-table-column>
                        </el-table>-->
                    </el-tab-pane>
                </el-tabs>
            </li>
            <li class="resize" ref="resize">
                <i class="el-icon-caret-right" @click="leftt(0)"></i>
                <i class="el-icon-caret-left" @click="leftt(1)"></i>
            </li>
            <li class="mid" ref="mid">
                <div  style="float:right;position: relative;">
                    <el-button type="danger" size="mini" icon="el-icon-close" @click="colseEdit"></el-button>
                </div>
                <div>
                    <div style="width:840px;min-width:840px">
                        <table>
                        <tr>
                            <td style="width:60px;min-width:60px">{{ $t('getapi[2095]') }}</td>
                            <td style="width:150px;min-width:150px">
                                <el-input type="text" size="mini" v-model="dataDetail.Head.order_no" :readonly="true" class="readO"></el-input>
                            </td>
                            <td style="width:60px;min-width:60px">{{ $t('getapi[1861]') }}</td>
                            <td style="width:100px;min-width:100px">
                                <el-input type="text" size="mini" :value="dataDetail.Head.order_status == 0?$t('getapi[1422]'):$t('getapi[3607]')" :readonly="true" class="readO"></el-input>
                            </td>
                            <td style="width:60px;min-width:60px">{{ $t('getapi[1862]') }}</td>
                            <td style="width:100px;min-width:100px">
                                <el-input type="text" size="mini" :value="expsfinancestatus(dataDetail.Head.finance_status)" :readonly="true" class="readO"></el-input>
                            </td>
                            <td style="width:30px;min-width:30px">{{ $t('getapi[2096]') }}</td>
                            <td style="width:50px;min-width:50px">
                                <el-checkbox  v-model="dataDetail.Head.negative_flag"  :true-label=1 :false-label=0 :disabled="true"></el-checkbox>
                            </td>
                            <td style="width:60px;min-width:60px">{{ $t('getapi[4642]') }}</td>
                            <td style="width:150px;min-width:150px">
                                <el-input type="text" size="mini" v-model="dataDetail.Head.coll_sign"  v-show="dataDetail.Head.order_status != 0" :readonly="true" class="readO"></el-input>
                                <routejump :urlNo="41" v-show="dataDetail.Head.order_status == 0">
                                <el-input  type="text" v-model="dataDetail.Head.coll_sign"
                                           readonly
                                           class="mcolor"
                                           size="mini"

                                >
                                    <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectcollsign()"></i>
                                </el-input>
                                </routejump>
                            </td>
                            <td style="width:60px;min-width:60px">{{ $t('getapi[13457]') }} </td>
                            <td style="width:80px;min-width:80px">       
                                <el-checkbox v-model="dataDetail.Head.single_measure" disabled="true" :true-label=1 :false-label=0></el-checkbox>
                            </td>
                        </tr>
                        <tr>
                            <td>{{ $t('getapi[4470]') }}</td>
                            <td>
                                <el-input type="text" size="mini" v-model="dataDetail.Head.regist_person"  v-show="dataDetail.Head.order_status != 0" :readonly="true" class="readO"></el-input>
                                <routejump :urlNo="6" v-show="dataDetail.Head.order_status == 0">
                                <el-input  type="text" v-model="dataDetail.Head.regist_person"
                                           readonly
                                           size="mini"
                                           class="mcolor"

                                >
                                    <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectperson(2)"></i>
                                </el-input>
                                </routejump>
                            </td>
                            <td>{{ $t('getapi[4472]') }}</td>
                            <td>
                                <el-input type="text" size="mini" v-model="dataDetail.Head.keep_person"  v-show="dataDetail.Head.order_status != 0" :readonly="true" class="readO"></el-input>
                                <routejump :urlNo="6" v-show="dataDetail.Head.order_status == 0">
                                <el-input  type="text" v-model="dataDetail.Head.keep_person"
                                           readonly
                                           size="mini"
                                           class="mcolor"

                                >
                                    <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectperson(1)"></i>
                                </el-input>
                                </routejump>
                            </td>
                            <td>{{ $t('getapi[4469]') }}</td>
                            <td colspan="3">
                                <routejump :urlNo="36">
                                <el-select filterable v-model="dataDetail.Head.issue_dept" size="mini" v-if="dataDetail.Head.order_status == 0" class="mcolor" @change="getIssueDept">
                                    <el-option v-for="item in issueDeptType" :key="item.Name" :label="item.Name"
                                               :value="item.Name"></el-option>
                                </el-select>
                                <el-select filterable v-model="dataDetail.Head.issue_dept" size="mini" v-if="dataDetail.Head.order_status != 0" :disabled="true">
                                    <el-option v-for="item in issueDeptType" :key="item.Name" :label="item.Name"
                                               :value="item.Name"></el-option>
                                </el-select>
                                </routejump>
                            </td>
                            <td>{{ $t('getapi[143]') }}</td>
                            <td>
                                <el-input type="text" size="mini" v-model="dataDetail.Head.remark"></el-input>
                            </td>
                        </tr>
                    </table>
                    </div>
                    <el-tabs :tab-position="'top'" type="" style="margin-top: 0px" @tab-click="selectInfo1">
                        <el-tab-pane :label="$t('getapi[4647]')" name="0">
                            <el-table
                                    id="xdetilpane-0"
                                    :data="dataDetail.MergeLists"
                                    :highlight-current-row="true"
                                    :height="tableHeight - 185"
                                    header-row-class-name="headerclass"
                                    border
                                    size="mini"
                                    style="width: 100%; margin-top:5px"
                                    ref="singleTable3"
                            >
                                <el-table-column type="selection" v-if="false"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="line_no" :label="$t('getapi[1425]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')" width="150"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[113]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_name" :label="$t('getapi[116]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_spec" :label="$t('getapi[125]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_model" :label="$t('getapi[124]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="assist_measure_unit" :label="$t('getapi[916]')"></el-table-column>
                                <el-table-column prop="assist_merge_qty" :label="$t('getapi[4593]')" align="right">
                                    <template scope="scope" v-if="dataDetail.Head.order_status == 0">
                                        <el-input v-model="scope.row.assist_merge_qty" type="number" :disabled="dataDetail.Head.single_measure==1" autocomplete="off" title="" @mousewheel.native.prevent size="mini" @change="changeAssistMergeQty(scope.row)"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="merge_qty" :label="$t('getapi[4652]')">
                                    <template scope="scope" v-if="dataDetail.Head.order_status == 0">
                                        <el-input v-model="scope.row.merge_qty" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" @change="changeMergeQty(scope.row)"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column show-overflow-tooltip prop="qty_on_hand" :label="$t('getapi[2576]')" align="right"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="master_assist_rate" :label="$t('getapi[3599]')" align="right"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="create_qty" :label="$t('getapi[4523]')" align="right"></el-table-column>
                            </el-table>
                        </el-tab-pane>
                        <el-tab-pane :label="$t('getapi[4653]')" name="1">
                            <el-table
                                    id="xdetilpane-1"
                                    :data="dataDetail.SoLists"
                                    :highlight-current-row="true"
                                    :height="tableHeight - 185"
                                    header-row-class-name="headerclass"
                                    border
                                    size="mini"
                                    style="width: 100%; margin-top:5px"
                                    ref="singleTable4"
                            >
                                <el-table-column type="selection" v-if="false"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="line_no" :label="$t('getapi[1425]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="so_code" :label="$t('getapi[4168]')" width="150"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="routing_sequence_no" :label="$t('getapi[573]')" align="right"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="routing_desc" :label="$t('getapi[575]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[113]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_name" :label="$t('getapi[116]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_spec" :label="$t('getapi[125]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_model" :label="$t('getapi[124]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="measure_unit" :label="$t('getapi[916]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="plan_qty" :label="$t('getapi[4245]')" align="right"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="actually_avg_qty" :label="$t('getapi[4654]')" align="right"></el-table-column>
                            </el-table>
                        </el-tab-pane>
                    </el-tabs>
                    <table>
                        <tr>
                            <td style="width:60px">{{ $t('getapi[1890]') }}</td>
                            <td style="width:150px;">
                                <el-input type="text" size="mini" v-model="dataDetail.Head.create_person" :readonly="true" class="readO"></el-input>
                            </td>
                            <td style="width:60px">{{ $t('getapi[733]') }}</td>
                            <td style="width:150px;">
                                <el-input type="text" size="mini" v-model="dataDetail.Head.modify_person" :readonly="true" class="readO"></el-input>
                            </td>
                            <td style="width:60px">{{ $t('getapi[497]') }}</td>
                            <td style="width:150px;">
                                <el-input type="text" size="mini" v-model="dataDetail.Head.audit_person" :readonly="true" class="readO"></el-input>
                            </td>
                            <td style="width:60px"></td>
                            <td style="width:150px;"></td>
                        </tr>
                        <tr>
                            <td>{{ $t('getapi[4583]') }}</td>
                            <td>
                                <el-date-picker v-model="dataDetail.Head.create_time" type="date" size="mini"
                                                style="width:100%" :readonly="true" class="readO"></el-date-picker>
                            </td>
                            <td>{{ $t('getapi[1210]') }}</td>
                            <td>
                                <el-date-picker v-model="dataDetail.Head.modify_time" type="date" size="mini"
                                                style="width:100%" :readonly="true" class="readO"></el-date-picker>
                            </td>
                            <td>{{ $t('getapi[496]') }}</td>
                            <td>
                                <el-date-picker v-model="dataDetail.Head.audit_time" type="date" size="mini"
                                                style="width:100%" :readonly="true" class="readO"></el-date-picker>
                            </td>
                            <td>{{ $t('getapi[1857]') }}</td>
                            <td>
                                <el-date-picker v-model="dataDetail.Head.finance_date" type="date" size="mini"
                                                style="width:100%" :readonly="true" class="readO"></el-date-picker>
                            </td>
                        </tr>
                    </table>
                </div>
            </li>
        </ul>
        <el-row v-if="SelectIndex == 0" class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <el-row v-if="SelectIndex == 1" class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange1"
                        @current-change="handleCurrentChange1"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize1"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total1"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <el-row v-if="SelectIndex == 2" class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange2"
                        @current-change="handleCurrentChange2"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize2"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total2"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <serce :isVisible="isVisible" queryData="ProSOCollecIssueHeadBoardViewInfo" ref="ser" @getser="serclick"></serce>
        <ctable :isVisible="false" :title="$t('getapi[4012]')" queryData="ProSOCollecIssueHeadBoardViewInfo" tabNo="0" ref="ctab"
                @getctab="sortclick"></ctable>
        <!--保管员 记账员-->
        <selector :isVisible="false" :isBatch=false :selectType="3" :isSplitPage=true :postUrl="'/Basic/Popup/GetEmployeeDataList'" @callback="getperson" ref="person"></selector>
        <!--程序单号-->
        <selector :isVisible="false" :isBatch=false :isSplitPage=true :postUrl="'/Pro/Board/GetBoardMergePopupDataList'" @callback="getcollsign" ref="collsign"></selector>
        <!--选择货位号-->
        <selector :isVisible="false" :isBatch=false :isSplitPage=true :postUrl="'/Inv/Action/GetActBoardCargoPositionPopupList'" @callback="getcargo" ref="cargo"></selector>
        <!--选择发料单号-->
        <selector :isVisible="false" :isBatch=false :isSplitPage=true :postUrl="'/Inv/Action/GetActBoardPopupDataList'" @callback="getorderno" ref="orderno"></selector>

        <el-dialog v-dialogDrag :visible.sync="visGuide" :title="$t('getapi[7110]')" width="25%" :close-on-click-modal="false" >
            <el-checkbox  v-model="negative_flag"  :true-label=1 :false-label=0></el-checkbox>{{ $t('getapi[4942]') }}

            <span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="visGuide = false">{{ $t('getapi[2054]') }}</el-button>
				<el-button type="primary" @click="confirmAdd" size="mini">{{$t('getapi[1146]')}}</el-button>
			</span>
        </el-dialog>
        <el-dialog v-dialogDrag :visible.sync="visExcute" width="80%" :close-on-click-modal="false" :show-close="false">
            <table>
                <tr>
                    <td style="width:60px">{{ $t('getapi[2255]') }}</td>
                    <td style="width:150px;">
                        <!--<el-input type="text" size="mini" v-model="dataDetailExcute.Head.order_no" :disabled="true"></el-input>-->
                        <el-input  type="text" v-model="dataDetailExcute.Head.order_no"
                                   readonly
                                   class="mcolor"
                                   size="mini"
                        >
                            <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectorderno"></i>
                        </el-input>
                    </td>
                    <td style="width:60px">{{ $t('getapi[4469]') }}</td>
                    <td style="width:150px;">
                        <el-input type="text" size="mini" v-model="dataDetailExcute.Head.issue_dept" :readonly="true" class="readO"></el-input>
                    </td>
                    <td style="width:100px;"><el-checkbox  v-model="dataDetailExcute.Head.negative_flag"  :true-label=1 :false-label=0 ></el-checkbox>{{ $t('getapi[2096]') }}</td>
                    <td style="width:60px;min-width:60px">{{ $t('getapi[13457]') }} </td>
                    <td style="width:80px;min-width:80px">       
                        <el-checkbox v-model="dataDetailExcute.Head.single_measure" disabled="true" :true-label=1 :false-label=0></el-checkbox>
                    </td>
                </tr>
            </table>
            <el-tabs :tab-position="'top'" type="" style="margin-top: 0px">
                <el-tab-pane :label="$t('getapi[5057]')" name="0">
                    <el-table
                            :data="dataDetailExcute.Lists"
                            :highlight-current-row="true"
                            :height="tableHeight - 255"
                            border
                            size="mini"
                            style="width: 100%; margin-top:5px"
                    >
                        <el-table-column type="selection" v-if="false"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="line_no" :label="$t('getapi[2239]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')" width="150"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[149]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="part_name" :label="$t('getapi[116]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="part_cost" :label="$t('getapi[2248]')"></el-table-column>
                        <el-table-column prop="batch_no" :label="$t('getapi[1763]')">
                            <template scope="scope">
                                <el-input v-model="scope.row.batch_no" type="text" size="mini" oninput="value=value.replace(/(^\s*)|(\s*$)/g,'')"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column prop="sequence_no" :label="$t('getapi[1764]')">
                            <template scope="scope">
                                <el-input v-model="scope.row.sequence_no" type="text" size="mini" oninput="value=value.replace(/(^\s*)|(\s*$)/g,'')"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column prop="is_audit" :label="$t('getapi[2249]')">
                            <template scope="scope">
                                <el-checkbox  v-model="scope.row.is_audit"  :true-label=1 :false-label=0 ></el-checkbox>
                            </template>
                        </el-table-column>
                        <el-table-column show-overflow-tooltip prop="operation_code" :label="$t('getapi[2250]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="direction" :label="$t('getapi[2251]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="trans_qty" :label="$t('getapi[2242]')" align="right"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="trans_qty_input" :label="$t('getapi[2207]')" align="right"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="measureunit" :label="$t('getapi[3100]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="operation_person" :label="$t('getapi[346]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="trans_time" :label="$t('getapi[2254]')"></el-table-column>
                        <el-table-column prop="remark" :label="$t('getapi[143]')">
                            <template scope="scope">
                                <el-input v-model="scope.row.remark" type="text" size="mini"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column prop="cargo_position" :label="$t('getapi[1842]')">
                            <template scope="scope">
                                <el-input  type="text" v-model="scope.row.cargo_position"
                                           readonly
                                           class="mcolor"
                                           size="mini"
                                >
                                    <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectcargo(scope)"></i>
                                </el-input>
                            </template>
                        </el-table-column>
                        <el-table-column show-overflow-tooltip prop="assist_trans_qty" :label="$t('getapi[2244]')" align="right"></el-table-column>
                        <el-table-column prop="assist_trans_qty_input" :label="$t('getapi[2245]')">
                            <template scope="scope">
                                <el-input v-model="scope.row.assist_trans_qty_input" :disabled="dataDetailExcute.Head.single_measure==1" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" @change="changeassisttransqtyinput(scope)"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column show-overflow-tooltip prop="assist_measureunit" :label="$t('getapi[130]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="assist_qty_on_hand" :label="$t('getapi[2243]')" align="right"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="receive_time" :label="$t('getapi[2100]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="expiry_date" :label="$t('getapi[225]')"></el-table-column>
                    </el-table>
                </el-tab-pane>
            </el-tabs>
            <span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="visExcute = false" :disabled="!btn.closeExecute">{{ $t('getapi[2054]')}}</el-button>
				<el-button type="primary" @click="saveActBoardBillInfo" :disabled="!btn.saveActBoardBillInfo" size="mini">{{ $t('getapi[937]')}}</el-button>
			</span>
        </el-dialog>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import { Loading } from 'element-ui';
    export default {
        name: '2_boardissueview',
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight3- Common.reduceTableHeight2,
                    maxHeight: this.$windowSize.tableHeight3- Common.reduceTableHeight2,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                tableHeader: [],
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                DbTbNames: '',
                dataSet: [], // 主表数据
                pageIndex: 1, // 当前页
                pageSize: this.$http.getPageSize('2_boardissueview'), // 当前页数据量
                total: 0, // 数据总量
                SelectIndex: 0, //当前页面
                RightSelectIndex: '0',
                dataSet1: [], // 主表数据
                pageIndex1: 1, // 当前页
                pageSize1: this.$http.getPageSize('2_boardissueview1'), // 当前页数据量
                total1: 0, // 数据总量
                dataSet2: [], // 主表数据
                pageIndex2: 1, // 当前页
                pageSize2: this.$http.getPageSize('2_boardissueview2'), // 当前页数据量
                total2: 0, // 数据总量
                loading: false, // 主表加载状态
                reduceTableHeight: Common.reduceTableHeight2,
                dataDetail:{
                    Head:{},
                    MergeLists:[],
                    SoLists:[]
                },
                oldDataDetail: '',
                SignList: [],
                selectData: [],
                selectData1: [],
                selectData2: [],
                btn:{
                    closeExecute: true,
                    saveActBoardBillInfo: true
                },
                visGuide: false,
                visExcute: false,
                negative_flag: 0, // 新建时是否选择红字
                personType: 1, // 选择人员的类型
                dataDetailExcute: {
                    Head: {},
                    Lists: []
                },
                rowindexcargo: '',
                oldrow: '',
                iscontinuedblclick: true,
                oldIssueDept: '', // 板材专用发料的这个领料部门新建的时候请默认是上一笔选的领料部门
                timeId: null,
                scrollTop:0,
                scrollTop1:0,
                scrollTop2:0,
                scrollTop3:0,
                scrollTop4:0,
            };
        },
        watch: {
            /*dataSet: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(that.SelectIndex)
                })
            },
            dataSet1: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(that.SelectIndex)
                })
            },
            dataSet2: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(that.SelectIndex)
                })
            },
            'dataDetail.MergeLists': function(){
                let that = this
                that.$nextTick(function() {
                    that.$processdata.initFormRight(this.RightSelectIndex)
                })
            },
            'dataDetail.SoLists': function(){
                let that = this
                that.$nextTick(function() {
                    that.$processdata.initFormRight(this.RightSelectIndex)
                })
            },*/
        },
        mounted: function () {
            let that = this;
            that.colsort();
            that.$processdata.pushModelCache('2_boardissueview', that)
            that.userData = JSON.parse(sessionStorage.getItem('userData'));
            that.user = that.userData.username;
            that.issueDeptType = Array.methods.getIssueDeptWithPFLAG();
            that.$limits.dragControllerDiv();
            that.oldDataDetail = JSON.stringify(that.dataDetail)
            that.confirmAdd()
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
                that.$refs.singleTable1.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop1 = res.target.scrollTop
                },false)
                that.$refs.singleTable2.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop2 = res.target.scrollTop
                },false)
                that.$refs.singleTable3.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop3 = res.target.scrollTop
                },false)
                that.$refs.singleTable4.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop4 = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                    this.$refs.singleTable1.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop1;
                    this.$refs.singleTable2.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop2;
                    this.$refs.singleTable3.bodyWrapper.scrollTop =this.scrollTop3;
                    this.$refs.singleTable4.bodyWrapper.scrollTop =this.scrollTop4;
                }, 13)
            })
        },
        methods: {
            colsort() {
                let that = this;
                that.$loadviewfields.Fileds('ProSOCollecIssueHeadBoardViewInfo', 0, PFileds => {
                    that.tableHeader = PFileds;
                });
            },
            sortclick(val) {
                if (val == 1) {
                    this.colsort();
                }
            },
            // 修改表格顺序
            opentable() {
                this.$refs.ctab.clearInputs(true);
            },
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[4012]"),this.$t("getapi[6588]"));
            },
            //type 1 一览权限 、2 编辑界面权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
                // 一览，管理权限控制
                if(!this.$limits.menuvisible("plv2", 488, 1)){
                    var value = that.$limits.newOperationAuthorityView('plv2', 499, 1, that.total);
                    that.$refs.SetBtn.SetButtonEnable(value);
                } else {
                    if (that.$limits.authority('plv2', 488, 1) == 1) {
                        //只读权
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                    }
                    if (that.$limits.authority('plv2', 488, 1) == 2) {
                        if (that.$limits.authority('plv2', 288, 1) == 1) {
                            //只读权
                            that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                        }
                        if (that.$limits.authority('plv2', 488, 1) == 2) {
                            if (that.$limits.authority('plv3', 488,1) == 0) {
                                that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                            }
                            //操作权
                            if (that.$limits.authority('plv3', 488,1) == 1) {
                                //编辑级
                                if(!that.$limits.fnIsEmpty(that.dataDetail.Head.order_no)){
                                    if(that.dataDetail.Head.order_status > 0){
                                        that.$refs.SetBtn.SetButtonEnable('create,search,refresh,export,print');
                                    } else {
                                        that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export,print');
                                    }
                                } else {
                                    that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export,print');
                                }
                            }
                            if (that.$limits.authority('plv3', 488, 1) == 2) {
                                //删除级
                                if(!that.$limits.fnIsEmpty(that.dataDetail.Head.order_no)){
                                    if (that.dataDetail.Head.order_status > 0) {
                                        that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export,print');
                                    } else {
                                        that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export,del,print');
                                    }
                                } else {
                                    that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export,print');
                                }
                            }
                        }
                    }
                }
                if(that.dataDetail.Head.order_status == 0 && that.dataDetail.Head.order_no != '') {
                    console.log(that.$limits.authority('plv2', 279, 1))
                    if (that.$limits.authority('plv2', 279, 1) > 0) {
                        that.$refs.SetBtn.SetOneBtnEnable('execute', true);
                    } else {
                        that.$refs.SetBtn.SetOneBtnEnable('execute', false);
                    }
                }
                that.btnauthority();
            },
            btnauthority() {
                let that = this
            },
            leftt(e) {
                var left = document.getElementsByClassName('left');
                var mid = document.getElementsByClassName('mid');
                var Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                if (e == 1) {
                    left[0].style.width = '0px';
                    mid[0].style.width = bw - 13 + 'px';
                } else {
                    left[0].style.width = bw - 50 + 'px';
                    mid[0].style.width = '0px';
                }
            },
            openEdit() {
                let that = this
                clearTimeout(that.timeId)
                if(!that.iscontinuedblclick){
                    return
                }
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '0px';
                mid[0].style.width = '100%';
            },
            colseEdit(){
                let that = this
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '100%';
                mid[0].style.width = '0px'
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.$http.savePageSize('2_boardissueview',val)
                this.getView();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
            },
            handleSizeChange1(val) {
                this.pageSize1 = val;
                this.$http.savePageSize('2_boardissueview1',val)
                this.getView();
            },
            handleCurrentChange1(val) {
                this.pageIndex1 = val;
                this.getView();
            },
            handleSizeChange2(val) {
                this.pageSize2 = val;
                this.$http.savePageSize('2_boardissueview2',val)
                this.getView();
            },
            handleCurrentChange2(val) {
                this.pageIndex2 = val;
                this.getView();
            },
            selectInfo(tab, event) {
                let that = this;
                that.SelectIndex = tab.name;
                that.getView();
                that.$nextTick(function(){
                    //that.$processdata.initForm(that.SelectIndex)
                });
            },
            selectInfo1(tab, event) {
                let that = this;
                that.RightSelectIndex = tab.name;
                that.$nextTick(function(){
                    that.$processdata.initFormRight(that.RightSelectIndex)
                });
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'ProSOCollecIssueHeadBoardViewInfo');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndex,
                    Param: datac
                };
                if(that.SelectIndex == 1){
                    data.PageIndex = that.pageIndex1
                    data.PageSize = that.pageSize1
                } else if(that.SelectIndex == 2){
                    data.PageIndex = that.pageIndex2
                    data.PageSize = that.pageSize2
                }
                that.$http.urlpost('/Pro/Board/BoardIssueViewDataList', data, function (res) {
                    if (res.Success == 1) {
                        if (that.SelectIndex == 0) {
                            that.dataSet = res.DataContent;
                            that.total = res.Totals;
                        } else if (that.SelectIndex == 1) {
                            that.dataSet1 = res.DataContent;
                            that.total1 = res.Totals;
                        } else if (that.SelectIndex == 2) {
                            that.dataSet2 = res.DataContent;
                            that.total2 = res.Totals;
                        }
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                    } else {
                        that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                    }
                    that.$nextTick(function () {
                        that.$processdata.initAllForm()
                    })
                });
            },
            // 根据ID获取详情数据
            editInfo(row) {
                let that = this
                if(that.code == row.order_no){
                    return
                }
                that.timeId = setTimeout(() => {
                    if(!this.$limits.menuvisible("plv2", 488, 1)){
                        return
                    }
                    if(that.oldDataDetail != JSON.stringify(that.dataDetail)){
                        that.$confirm(that.$t('getapi[8577]'), that.$t('getapi[194]'), {//'数据已发生变更还未保存，是否切换？'
                            confirmButtonText: that.$t('getapi[2052]'),
                            cancelButtonText: that.$t('getapi[2053]'),
                            closeOnClickModal: false,
                            type: 'warning'
                        })
                            .then(() => {
                                that.iscontinuedblclick = true
                                that.oldrow = row
                                that.code = row.order_no
                                that.getDetail(row.order_no)
                            })
                            .catch(() => {
                                that.iscontinuedblclick = false
                                if (that.SelectIndex == 0) {
                                    that.$refs.singleTable.$refs.singleTable.setCurrentRow(that.oldrow);
                                } else if (that.SelectIndex == 1) {
                                    that.$refs.singleTable1.$refs.singleTable.setCurrentRow(that.oldrow);
                                } else if (that.SelectIndex == 2) {
                                    that.$refs.singleTable2.$refs.singleTable.setCurrentRow(that.oldrow);
                                }
                            });
                    } else {
                        that.iscontinuedblclick = true
                        that.oldrow = row
                        that.code = row.order_no
                        that.getDetail(row.order_no)
                    }
                }, 100);
            },
            // 新增
            add() {
                let that = this;
                if(that.oldDataDetail != JSON.stringify(that.dataDetail)){
                    that.$confirm(that.$t('getapi[3657]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后新建？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            let that = this;
                            that.openEdit()
                            that.negative_flag = 0
                            that.visGuide = true
                        });
                } else {
                    let that = this;
                    that.openEdit()
                    that.negative_flag = 0
                    that.visGuide = true
                }
            },
            confirmAdd(){
                let that = this
                that.addoredit = 0
                that.code = ''
                that.visGuide = false
                let date = Common.methods.getDate()
                that.dataDetail.Head = {
                    order_no:'',
                    order_status:0,
                    coll_sign:'',
                    boardspecial_flag:'',
                    finance_status:-1,
                    finance_date:'',
                    issue_dept:that.oldIssueDept == ''?'':that.oldIssueDept,
                    create_person:'',
                    create_time:'',
                    modify_person:'',
                    modify_time:'',
                    audit_person:"",
                    audit_time:null,
                    regist_person:'',
                    keep_person:'',
                    negative_flag:that.negative_flag,
                    base_order_no:"",
                    remark:"",
                    po_code:null,
                    vender_code:null,
                    vender_name:null,
                    verify_type:0,
                    order_type:0,
                    concurrent_time:null,
                    single_measure:0
                }
                that.dataDetail.MergeLists = []
                that.dataDetail.SoLists = []
                that.oldDataDetail = JSON.stringify(that.dataDetail)
                that.authority();
            },
            // 刷新
            reflash() {
                /*let that = this;
                if(that.addoredit == 0){
                    that.confirmAdd()
                } else {
                    that.getDetail(that.code)
                }
                that.getView();*/
                let that = this;
                if(that.oldDataDetail != JSON.stringify(that.dataDetail)){
                    that.$confirm(that.$t('getapi[3659]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后刷新？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            if(that.addoredit == 0){
                                that.getView();
                                that.confirmAdd()
                            } else {
                                that.getView();
                                that.getDetail(that.code)
                            }
                        });
                } else {
                    if(that.addoredit == 0){
                        that.getView();
                        that.confirmAdd()
                    } else {
                        that.getView();
                        that.getDetail(that.code)
                    }
                }
            },
            // 导出
            exps() {
                /*let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Ids: '',
                    Param: datac
                };
                that.$refs.SetBtn.SetOneBtnEnable('exps',false);
                that.$http.urlpost('/Pro/Board/BoardIssueViewToExecl', parm, function (res) {
                    that.$refs.SetBtn.SetOneBtnEnable('exps',true);
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });*/
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    query_sign: "ProSOCollecIssueHeadBoardViewInfo",
                    fromname: that.$t('getapi[4012]'),
                    SelectIndex: 0,
                    MultyVer: that.$processdata.getLanguage(),
                    Param: datac
                };
                that.$processdata.commonExport(parm)
            },
            // 保存
            save() {
                let that = this;
                let parm = that.dataDetail
                parm.LangType = that.$processdata.getLang()
                that.$refs.SetBtn.SetOneBtnEnable('save', false);
                that.$http.urlpost('/Pro/Board/BoardSaveData', parm, function(res) {
                    that.$refs.SetBtn.SetOneBtnEnable('save', true);
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.code = res.UniqueNum
                        that.getDetail(res.UniqueNum)
                    }
                });
            },
            print() {
                //判断状态
                let that = this;
                if(that.$limits.fnIsEmpty(that.dataDetail.Head.order_no)){ return; }
                that.$refs.SetBtn.SetOneBtnEnable('print', false);
                that.loading = true;
                let parm = {
                    po_no: that.dataDetail.Head.order_no,
                    TemplateName: '22板材发料单.xlsx',
                    notice_person:that.dataDetail.Head.audit_person
                };
                that.$http.urlpost('/Print/SCPrint', parm, function (res) {
                that.$refs.SetBtn.SetOneBtnEnable('print', true);
                if (res.Success == 1) {
                    let hrefurl = res.Key;
                    window.open(hrefurl);
                } 
                that.loading = false;
            });
            },
            getDetail(code) {
                let that = this;
                that.addoredit = 1
                let parm = {
                    Code: code
                };
                let loadingInstance = Loading.service(Common.maskoption);
                that.$http.urlpost('/Pro/Board/GetBoardBillInfo', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataDetail = res.DataContent;
                        that.oldIssueDept = that.dataDetail.Head.issue_dept
                        that.oldDataDetail = JSON.stringify(that.dataDetail)
                        that.authority();
                        that.btnauthority()
                    }
                    loadingInstance.close()
                    that.$nextTick(function () {
                        that.$processdata.initAllForm()
                    })
                });
            },
            handleSelectionChange(val){
                let that = this;
                that.selectData = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectData.push(val[i]);
                }
                that.btnauthority()
            },
            handleSelectionChange1(val){
                let that = this;
                that.selectData1 = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectData1.push(val[i]);
                }
                that.btnauthority()
            },
            handleSelectionChange2(val){
                let that = this;
                that.selectData2 = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectData2.push(val[i]);
                }
                that.btnauthority()
            },
            del(){
                let that = this;
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            order_no: that.dataDetail.Head.order_no,
                            order_status: that.dataDetail.Head.order_status,
                            modify_time: that.dataDetail.Head.modify_time
                        }
                        that.$refs.SetBtn.SetOneBtnEnable('del',false);
                        that.$http.urlpost('/Pro/Board/DelBoardBill', parm, function (res) {
                            that.$refs.SetBtn.SetOneBtnEnable('del',true);
                            if (res.Success == 1) {
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                that.getView()
                                that.negative_flag = 0 // 删除后默认新建蓝字发料单
                                that.confirmAdd()
                            }
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            expsfinancestatus(val){
                let that = this
                if (val == 0) {
                    return that.$t('getapi[1901]')//'核算';
                } else if (val == 1) {
                    return that.$t('getapi[3753]')//'记账';
                } else if (val == 2) {
                    return that.$t('getapi[3754]')//'月结';
                } else {
                    return '';
                }
            },
            selectperson(val){
                let that = this;
                that.personType = val
                that.$refs.person.clearInput(true);
            },
            getperson(data){
                let that = this
                console.log(data)
                if(that.personType == 1){
                    that.dataDetail.Head.keep_person = data.name
                } else if(that.personType == 2){
                    that.dataDetail.Head.regist_person = data.name
                }
            },
            selectcollsign(val){
                let that = this;
                that.$refs.collsign.clearInput(true);
            },
            getcollsign(data){
                let that = this
                console.log(data)
                that.dataDetail.Head.coll_sign = data.coll_sign
                that.dataDetail.Head.single_measure = data.single_measure                
                that.getCollSignDetail()
            },
            // 根据程序单号获取明细信息
            getCollSignDetail(){
                let that = this
                let parm = {
                    order_no: that.dataDetail.Head.order_no,
                    coll_sign: that.dataDetail.Head.coll_sign,
                    negative_flag: that.dataDetail.Head.negative_flag,
                    single_measure: that.dataDetail.Head.single_measure
                }
                that.$http.urlpost('/Pro/Board/GetSelCollSignLoadInfo', parm, function (res) {
                    if (res.Success == 1) {
                        let M = res.DataContent.MergeLists
                        let MdataDetailLineNo = 1
                        that.dataDetail.MergeLists = []
                        for (let i = 0; i < that.dataDetail.MergeLists.length; i++) {
                            if (that.dataDetail.MergeLists[i].line_no >= MdataDetailLineNo) {
                                MdataDetailLineNo = that.dataDetail.MergeLists[i].line_no + 1
                            }
                        }
                        for(let i = 0;i<M.length;i++){
                            that.dataDetail.MergeLists = [...that.dataDetail.MergeLists,{
                                exclusively_id: M[i].exclusively_id,
                                relation_order_no: M[i].relation_order_no,
                                line_no: MdataDetailLineNo++,
                                part_id: M[i].part_id,
                                part_code: M[i].part_code,
                                part_version: M[i].part_version,
                                part_name: M[i].part_name,
                                part_spec: M[i].part_spec,
                                part_model: M[i].part_model,
                                measure_unit: M[i].measure_unit,
                                assist_measure_unit: M[i].assist_measure_unit,
                                merge_qty: M[i].merge_qty,
                                assist_merge_qty: M[i].assist_merge_qty,
                                create_qty: M[i].create_qty,
                                master_assist_rate: M[i].master_assist_rate,
                                qty_on_hand: M[i].qty_on_hand
                            }]
                        }
                        let S = res.DataContent.SoLists
                        let SdataDetailLineNo = 1
                        that.dataDetail.SoLists = []
                        for (let i = 0; i < that.dataDetail.SoLists.length; i++) {
                            if (that.dataDetail.SoLists[i].line_no >= SdataDetailLineNo) {
                                SdataDetailLineNo = that.dataDetail.SoLists[i].line_no + 1
                            }
                        }
                        for(let i = 0;i<S.length;i++){
                            that.dataDetail.SoLists = [...that.dataDetail.SoLists,{
                                exclusively_id: S[i].exclusively_id,
                                relation_order_no: S[i].relation_order_no,
                                line_no: SdataDetailLineNo++,
                                part_id: S[i].part_id,
                                part_code: S[i].part_code,
                                part_version: S[i].part_version,
                                part_name: S[i].part_name,
                                part_spec: S[i].part_spec,
                                part_model: S[i].part_model,
                                so_code: S[i].so_code,
                                routing_sequence_no: S[i].routing_sequence_no,
                                routing_desc: S[i].routing_desc,
                                measure_unit: S[i].measure_unit,
                                plan_qty: S[i].plan_qty,
                                actually_avg_qty: S[i].actually_avg_qty,
                                unit_price: S[i].unit_price,
                                line_net_total_amount: S[i].line_net_total_amount,
                                line_remark: S[i].line_remark
                            }]
                        }
                        /*that.dataDetail.MergeLists = res.DataContent.MergeLists
                        that.dataDetail.SoLists = res.DataContent.SoLists*/
                        for(let i = 0;i<that.dataDetail.MergeLists.length;i++){
                            that.dataDetail.MergeLists[i].merge_qty = (that.dataDetail.MergeLists[i].assist_merge_qty * that.dataDetail.MergeLists[i].master_assist_rate).toFixed(4)
                            that.setSoQty(that.dataDetail.MergeLists[i])
                        }
                        for(let i = 0;i<that.dataDetail.MergeLists.length;i++){
                            let newAssistQty = that.dataDetail.MergeLists[i].merge_qty / that.dataDetail.MergeLists[i].master_assist_rate
                            if(that.dataDetail.MergeLists[i].assist_merge_qty - newAssistQty > 1){
                                that.$message.warning(that.$t('getapi[4674]'))//板材重量的调整超出了一张板的限额，请重新检查
                                that.dataDetail.MergeLists[i].merge_qty = (that.dataDetail.MergeLists[i].assist_merge_qty * that.dataDetail.MergeLists[i].master_assist_rate).toFixed(4)
                            } else {
                                that.setSoQty(that.dataDetail.MergeLists[i])
                            }
                        }
                    }
                });
            },
            changeAssistMergeQty(row){
                let that = this
                row.merge_qty = (row.assist_merge_qty * row.master_assist_rate).toFixed(4)
                that.setSoQty(row)
            },
            changeMergeQty(row){
                let that = this
                if(that.dataDetail.Head.single_measure==0){
                    let newAssistQty = row.merge_qty / row.master_assist_rate
                    if(row.assist_merge_qty - newAssistQty > 1){
                        that.$message.warning(that.$t('getapi[4674]'))//'板材重量的调整超出了一张板的限额，请重新检查'
                        row.merge_qty = (row.assist_merge_qty * row.master_assist_rate).toFixed(4)
                    } else {
                        that.setSoQty(row)
                    }
                }
                else{
                    that.setSoQty(row)
                }
            },
            setSoQty(row){
                let that = this
                let SumPlanQty
                let ActualQty
                let MergeQty
                let PartID
                let RealityQty
                SumPlanQty = 0
                MergeQty = 0
                ActualQty = 0
                PartID = ""
                RealityQty = 0

                PartID = row.part_id
                MergeQty = parseFloat(row.merge_qty)

                for (let j = 0; j < that.dataDetail.SoLists.length; j++)
                {
                    if (PartID == that.dataDetail.SoLists[j].part_id)
                    {
                        SumPlanQty = SumPlanQty + parseFloat(that.dataDetail.SoLists[j].plan_qty);
                    }
                }
                for (let j = 0; j < that.dataDetail.SoLists.length; j++)
                {
                    if (PartID == that.dataDetail.SoLists[j].part_id)
                    {
                        ActualQty = MergeQty * parseFloat(that.dataDetail.SoLists[j].plan_qty) / SumPlanQty;
                        that.dataDetail.SoLists[j].actually_avg_qty = ActualQty.toFixed(4);
                        RealityQty = RealityQty + parseFloat(that.dataDetail.SoLists[j].actually_avg_qty)
                    }
                }
                if (RealityQty != MergeQty && that.dataDetail.SoLists.length > 0)
                {
                    for (let i = 0; i < that.dataDetail.SoLists.length; i++)
                    {
                        if (that.dataDetail.SoLists[i].actually_avg_qty != 0)
                        {
                            that.dataDetail.SoLists[i].actually_avg_qty = that.$processdata.mathRound4(parseFloat(that.dataDetail.SoLists[i].actually_avg_qty) + MergeQty - RealityQty);
                            break;
                        }
                    }
                }
            },
            execute(){
                let that = this
                that.visExcute = true
                that.getActBoardBillInfo(that.dataDetail.Head.order_no)
                that.btn.saveActBoardBillInfo = true
            },
            getActBoardBillInfo(code){
                let that = this
                that.btn.saveActBoardBillInfo = true
                let parm = {
                    Code: code
                }
                that.$http.urlpost('/Inv/Action/GetActBoardBillInfo', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataDetailExcute = res.DataContent
                    }
                });
            },
            saveActBoardBillInfo(){
                let that = this
                let parm = that.dataDetailExcute
                parm.LangType = that.$processdata.getLang()
                that.btn.saveActBoardBillInfo = false
                that.btn.closeExecute = false
                let loadingInstance = Loading.service(Common.maskoption1);
                that.$http.urlpost('/Inv/Action/ActBoardSaveData', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                    } else {
                        that.btn.saveActBoardBillInfo = true
                    }
                    that.btn.closeExecute = true
                    loadingInstance.close()
                });
            },
            // 选择货位
            selectcargo(row){
                let that = this;
                that.rowindexcargo = row.$index
                that.$refs.cargo.clearInput(true);
            },
            getcargo(data){
                let that = this
                console.log(data)
                that.dataDetailExcute.Lists[that.rowindexcargo].cargo_position = data.cargoposition_code
            },
            // 选择发料单号
            selectorderno(row){
                let that = this;
                that.$refs.orderno.clearInput(true);
            },
            getorderno(data){
                let that = this
                console.log(data)
                that.dataDetailExcute.Head.order_no = data.order_no
                that.dataDetailExcute.Head.issue_dept = data.issue_dept
                that.dataDetailExcute.Head.negative_flag = data.negative_flag
                that.getActBoardBillInfo(that.dataDetailExcute.Head.order_no)
            },
            // 修改次数量
            changeassisttransqtyinput(row) {
                let that = this
                let index = row.$index
                let parm = {
                    part_code: that.dataDetailExcute.Lists[index].part_code,
                    part_version: that.dataDetailExcute.Lists[index].part_version
                }
                that.$http.urlpost('/Inv/Action/GetPartMasterAssistRate', parm, function (res) {
                    if (res.Success == 1) {
                        let rate = res.DataContent
                        that.dataDetailExcute.Lists[index].trans_qty_input = that.$processdata.mathRound4(that.dataDetailExcute.Lists[index].assist_trans_qty_input * rate)
                    }
                });
            },
            checkDataChange(){
                let that = this
                //如果无保存权限，直接关闭
                if(that.$limits.authority('plv3', 488,1) < 1){
                    return false
                }
                let flag =  that.oldDataDetail != JSON.stringify(that.dataDetail)
                return flag
            },
            //获取领料部门
            getIssueDept(val){
                let that = this
                that.oldIssueDept = val
            }
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }

    /deep/ .green {
        background: #c8ffbb;
    }
    /deep/ .red {
        background: #ff7879;
    }

    /deep/.el-table .hidden-row {
        display: none;
    }
</style>
